import Img from '@/lib/Img'
import React from 'react'

const Content = ({ title, subtitle, image }) => (
	<dl className="text-center richtext-sm">
		<dt className="richtext-sm">
			<figure className="rounded-full overflow-hidden">
				<Img image={image} alt={title} />
			</figure>
			<p className="h3 text-grounding-navy">{title}</p>
		</dt>
		<dd className="technical">{subtitle}</dd>
	</dl>
)

const Partner = ({ link, ...props }) => !!link
	? <a href={link}><Content {...props} /></a>
	: <Content {...props} />

export default Partner
